/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { QuestionnaireStrictHttpResponse } from '../../questionnaire-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QuestionnaireListItemModel } from '../../models/questionnaire-list-item-model';

export interface ApiConsumerQuestionnaireListGet$Params {
  activeOnly?: boolean;
}

export function apiConsumerQuestionnaireListGet(http: HttpClient, rootUrl: string, params?: ApiConsumerQuestionnaireListGet$Params, context?: HttpContext): Observable<QuestionnaireStrictHttpResponse<Array<QuestionnaireListItemModel>>> {
  const rb = new RequestBuilder(rootUrl, apiConsumerQuestionnaireListGet.PATH, 'get');
  if (params) {
    rb.query('activeOnly', params.activeOnly, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as QuestionnaireStrictHttpResponse<Array<QuestionnaireListItemModel>>;
    })
  );
}

apiConsumerQuestionnaireListGet.PATH = '/api/consumer/questionnaire/list';
